import { defineMessages } from 'react-intl-next';

export default defineMessages({
    noSearchResultTitle: {
        defaultMessage: 'No matching search results',
        description: 'Text to tell the user that there was no search results found after they have conducted a search',
        id: 'cv.search.results.none.found',
    },

    noSearchResultText: {
        defaultMessage: 'Try using more general search terms.',
        description: 'Text to tell the user how to proceed after finding no search results',
        id: 'cv.search.results.none.found.text',
    },
});
